import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import AnimationCommon from "../common/AnimationCommon";
import CustomBreadcrumb from "../common/Breadcrumb";
import Footer from "../components/footer";
import BlogDetailsContent from "./BlogDetailsContent";
import BlogNav from "./BlogNav";
import Sidebar from "./Sidebar";

const BlogDetailLeftSidebar = () => {
  useEffect(() => {
    document.body.classList.remove("landing-page");
    document.body.classList.add("inner-page");
  }, []);
  return (
    <div>
    <BlogNav/>
      <div className='page-margin'>
        <CustomBreadcrumb items={"Blog details with left-sidebar"} />
        <section className='blog-page blog-detail-left-page'>
          <Container>
            <Row>
              <Col sm={12} md={8} lg={9}>
                <BlogDetailsContent />
              </Col>
              <Sidebar align='first' />
            </Row>
          </Container>
          <AnimationCommon />
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default BlogDetailLeftSidebar;
